import {FC} from 'react';
import {MenuSidebar} from '@components/MenuSidebar';
import {Button} from '@components/Button';
import {Icon} from '@components/Icon';
import {Nav} from '@components/Nav';
import {FormattedMessage} from 'react-intl';
import {Sidebar} from '@components/Sidebar';
import {Row} from '@components/Row';
import {Col} from '@components/Col';
import {VisuallyHidden} from '@components/VisuallyHidden';
import {getLocalizedRoute, isRoute, routes} from '@utils/routes';
import Link from 'next/link';
import {useLocale} from '@utils/locale';
import {useRouter} from 'next/router';

export type SidebarMenuLogoutProps = {
    show: boolean;
    onHide: () => void;
};

export const SidebarMenuLogout: FC<SidebarMenuLogoutProps> = ({show, onHide}) => {
    const locale = useLocale();
    const router = useRouter();

    return (
        <Sidebar specialVariant="menu" show={show} onHide={onHide}>
            <MenuSidebar>
                <MenuSidebar.Header>
                    <Row className="align-items-center justify-content-between flex-nowrap">
                        <Col xs={{span: 'auto', order: 'last'}}>
                            <Button variant="icon" size="sm" onClick={onHide}>
                                <VisuallyHidden>
                                    <FormattedMessage defaultMessage={'Zavřít'} />
                                </VisuallyHidden>
                                <Icon.Close position="middle" />
                            </Button>
                        </Col>
                        <Col xs="auto" className={'flex-shrink-1'}></Col>
                    </Row>
                </MenuSidebar.Header>

                <Nav as="ul" className="flex-column">
                    <Nav.Item as="li" onClick={onHide}>
                        <Link href={getLocalizedRoute(routes.list, locale, {list: ''})} passHref>
                            <Nav.Link active={isRoute(router.asPath, routes.list, locale)}>
                                <FormattedMessage defaultMessage="Nemovitosti" />
                            </Nav.Link>
                        </Link>
                    </Nav.Item>
                    <Nav.Item as="li" onClick={onHide}>
                        <Link href={getLocalizedRoute(routes.serviceCentreIntroCustomer, locale)} passHref>
                            <Nav.Link href="#">
                                <FormattedMessage defaultMessage="Tipy pro zájemce" />
                            </Nav.Link>
                        </Link>
                    </Nav.Item>
                    <Nav.Item as="li" onClick={onHide}>
                        <Link href={getLocalizedRoute(routes.serviceCentrePremium, locale)} passHref>
                            <Nav.Link active={isRoute(router.asPath, routes.serviceCentrePremium, locale)}>
                                <FormattedMessage defaultMessage="Premium profil" />
                            </Nav.Link>
                        </Link>
                    </Nav.Item>
                    <Nav.Item as="li" onClick={onHide}>
                        <Link href={getLocalizedRoute(routes.serviceCentreSale, locale)} passHref>
                            <Nav.Link active={isRoute(router.asPath, routes.serviceCentreSale, locale)}>
                                <FormattedMessage defaultMessage="Služby" />
                            </Nav.Link>
                        </Link>
                    </Nav.Item>
                </Nav>
            </MenuSidebar>
        </Sidebar>
    );
};
